export default __webpack_public_path__ + "static/media/vegmomo.cb46daae.jpg";